"use client";

import TimeLinePanel from "components/Explore/timeLine/timeline";

/** Explore timeline container without outer card wrapper. */
export function ExploreTimelinePanelV2() {
  return <TimeLinePanel />;
}
